import { FEATURE_FLAGS } from "./feature-flag-constants";

interface LandingPagePreference {
  featureFlag: string;
  path: string;
}

interface MenuItem {
  key?: string;
  children?: MenuItem[];
}

const LANDING_PAGE_PREFERENCES: LandingPagePreference[] = [
  // Trial Home is the intended landing page for "Enter trial" whenever the trial
  // has it; the rest are fallbacks for trials without a home screen.
  {
    featureFlag: FEATURE_FLAGS.TRIAL_HOME_SCREEN,
    path: "/home",
  },
  {
    featureFlag: FEATURE_FLAGS.SITES_OVERVIEW,
    path: "/sites/overview",
  },
  {
    featureFlag: FEATURE_FLAGS.ASKVIVO,
    path: "/askvivo",
  },
  {
    featureFlag: FEATURE_FLAGS.SUBJECTS_OVERVIEW,
    path: "/subjects/overview",
  },
];

export const getAvailableMenuKeys = (menuItems: MenuItem[]): string[] =>
  menuItems.flatMap((item) => {
    if (item.children?.length) {
      return item.children
        .map((child) => child.key)
        .filter((key): key is string => typeof key === "string");
    }

    return typeof item.key === "string" ? [item.key] : [];
  });

export const getFirstAvailableMenuPath = (menuItems: MenuItem[]): string => {
  const [firstAvailableKey = "/404"] = getAvailableMenuKeys(menuItems);
  return firstAvailableKey;
};

export const getLandingPageFromFeatureFlags = (
  isFeatureFlagEnabled: (flag: string) => boolean,
  filteredMenuOptions: MenuItem[],
): string => {
  for (const preference of LANDING_PAGE_PREFERENCES) {
    if (isFeatureFlagEnabled(preference.featureFlag)) {
      return preference.path;
    }
  }

  return getFirstAvailableMenuPath(filteredMenuOptions);
};
